'use client';

import React, { useEffect } from 'react';
import NavBar from './NavBar';
import HeroSection from './HeroSection';
import BrandsMarquee from './BrandsMarquee';
import PartsCategories from './PartsCategories';
import WhyChooseUs from './WhyChooseUs';
import TestimonialsSection from './TestimonialsSection';
import ContactSection from './ContactSection';
import WhatsAppFAB from './WhatsAppFAB';
import Footer from '@/components/Footer';

export default function HomepageInteractive() {
  useEffect(() => {
    // Scroll reveal observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = document.querySelectorAll('.reveal-hidden, .reveal-hidden-scale');
    elements?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <>
      <NavBar />
      <main>
        <HeroSection />
        <BrandsMarquee />
        <PartsCategories />
        <WhyChooseUs />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppFAB />
    </>
  );
}